export default [
    [
        // {
        //     url: "#",
        //     name: "message.trust",
        //     slug: "#",
        //     icon: "TypeIcon",
        // },
        {
            url: "/",
            name: "message.summary",
            slug: "home",
            icon: "ClockIcon",
        },
        {
            url: "/credit-card",
            name: "message.creditCard",
            slug: "credit-card",
            icon: "CreditCardIcon",
        },
        {
            url: "/cash-management",
            name: "message.cashMangement",
            slug: "cash-management",
            icon: "DatabaseIcon",
        },
        {
            url: "/others-assets",
            name: "lang.others_assets",
            slug: "others-assets",
            icon: "LayersIcon",
        },
        {
            url: "/fixed-return",
            name: "lang.fixed_return",
            slug: "fixedReturn",
            icon: "ArchiveIcon",
        },
    ],
    [
        {
            url: "/customer",
            name: "message.customer",
            slug: "home",
            icon: "UsersIcon",
        },
        {
            url: "/planTemplate",
            name: "message.planTemplate",
            slug: "planTemplate",
            icon: "FileIcon",
        }
    ],
    [
        {
            name: "message.user",
            slug: "home",
            icon: "UsersIcon",
            submenu: [
                {
                    url: '/account_staff',
                    name: "message.staff",
                    slug: "dashboardAnalytics",
                },
                {
                    url: '/account_customer',
                    name: "message.customer",
                    slug: "dashboardECommerce",
                },
                {
                    url:'/approval',
                    name:'message.approvalUser',
                    slug:""
                }
            ]
        },
        {
            url: "/planTemplate",
            name: "message.planTemplate",
            slug: "planTemplate",
            icon: "FileIcon",
        },
        {
            url: "/dividend_approval",
            name: "message.dividendApproval",
            slug: "dividendApproval",
            icon: "CheckSquareIcon",
        },
    ],
]


